import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import clone from 'lodash/clone';
import { injectIntl, intlShape } from 'react-intl';
import {
    getProductTeachers,
    downloadTeacherRoll,
    clearFilterValue,
    changeFilterValue,
    updateSearchTerm,
    sortTeacherList,
    retrieveSelectedTeachers,
    openUnAssignTeachersModal,
    closeTeachersOperationConfirmationModal,
    unassignTeachers,
    openAddTeacherModal,
    closeAddTeacherModal,
    addTeacher,
    closeAddTeacherValidationModal,
    printTeacherSignInCard,
    addAnotherTeacherModal,
    openDeleteTeacherModal,
    deleteTeacherRequest,
    openBulkPasswordChangeTeachersModal,
    bulkPasswordChangeTeachersRequest,
    sendVerificationEmailRequest,
    closeVerificationModal
} from './actions';
import { resetUserClassroomRelation } from '../../containers/assign-user/actions';
import TeacherRoll from '../../components/teacher-roll/index';
import { createTeacherRows, isListDifferent } from '../../helpers/grid-util';
import { getProductClassrooms } from '../class-roll/actions';
import { showToast } from '../../components/toast/actions';
import messages from './messages';

class TeacherRollContainer extends Component {
    static propTypes = {
        isTeacherDataLoaded: PropTypes.bool,
        isClassroomDataLoaded: PropTypes.bool,
        isSaveInProgress: PropTypes.bool,
        isTeacherRollDownloaded: PropTypes.bool,
        isSignInCardDownloaded: PropTypes.bool,
        showAddTeacherValidationModal: PropTypes.bool,
        showModal: PropTypes.bool,
        showAddTeacherConfirmationModal: PropTypes.bool,
        addTeacherValidationMessage: PropTypes.string,
        lastAddedTeacherUserProfileId: PropTypes.number,
        teacher: PropTypes.object,
        dataFilterOption: PropTypes.object,
        teachers: PropTypes.arrayOf(PropTypes.object),
        teacherTitles: PropTypes.arrayOf(PropTypes.object),
        classrooms: PropTypes.arrayOf(PropTypes.object),
        filteredTeachers: PropTypes.arrayOf(PropTypes.object),
        selectedTeachers: PropTypes.arrayOf(PropTypes.number),
        selectedProduct: PropTypes.object,
        getProductTeachers: PropTypes.func,
        getProductClassrooms: PropTypes.func,
        downloadTeacherRoll: PropTypes.func,
        clearFilterValue: PropTypes.func,
        changeFilterValue: PropTypes.func,
        retrieveSelectedTeachers: PropTypes.func,
        updateSearchTerm: PropTypes.func,
        sortTeacherList: PropTypes.func,
        unassignTeachers: PropTypes.func,
        isUserOperationModalOpen: PropTypes.bool,
        isEmailVerificationModalOpen: PropTypes.bool,
        sendingEmailsResult: PropTypes.object,
        emailVerificationError: PropTypes.bool,
        refreshTeacherList: PropTypes.bool,
        openUnAssignTeachersModal: PropTypes.func,
        closeTeachersOperationConfirmationModal: PropTypes.func,
        disableConfirmationButtons: PropTypes.bool,
        openAddTeacherModal: PropTypes.func,
        closeAddTeacherModal: PropTypes.func,
        addTeacher: PropTypes.func,
        closeAddTeacherValidationModal: PropTypes.func,
        printTeacherSignInCard: PropTypes.func,
        addAnotherTeacherModal: PropTypes.func,
        openDeleteTeacherModal: PropTypes.func,
        deleteTeacherRequest: PropTypes.func,
        operationType: PropTypes.string,
        openBulkPasswordChangeTeachersModal: PropTypes.func,
        bulkPasswordChangeTeachersRequest: PropTypes.func,
        showToast: PropTypes.func,
        intl: intlShape.isRequired,
        deletingTeacher: PropTypes.bool,
        deleteSuccess: PropTypes.bool,
        notDeletedTeachers: PropTypes.arrayOf(PropTypes.object),
        sendVerificationEmailRequest: PropTypes.func,
        closeVerificationModal: PropTypes.func,
        resetUserClassroomRelation: PropTypes.func
    };

    static contextTypes = {
        router: PropTypes.object
    }

    constructor(props) {
        super(props);
        this.handleGridSort = this.handleGridSort.bind(this);
        this.rows = props.isTeacherDataLoaded ? createTeacherRows(props.filteredTeachers) : [];
        this.state = {
            rows: this.rows,
            dataFilterOption: this.props.dataFilterOption
        };

        this.handleOnPrintSignInCard = this.handleOnPrintSignInCard.bind(this);
        this.handleOnPrintMultipleSignInCard = this.handleOnPrintMultipleSignInCard.bind(this);
        this.handleOnTeacherUnassign = this.handleOnTeacherUnassign.bind(this);
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this);
        this.handleOnUnassignConfirm = this.handleOnUnassignConfirm.bind(this);
        this.filterClassrooms = this.filterClassrooms.bind(this);
        this.handleOnTeacherBulkPasswordChange = this.handleOnTeacherBulkPasswordChange.bind(this);
        this.handleOnTeacherBulkPasswordChangeNewValue = this.handleOnTeacherBulkPasswordChangeNewValue.bind(this);
        this.handleOnBulkPasswordChangeConfirm = this.handleOnBulkPasswordChangeConfirm.bind(this);
    }

    componentDidMount() {
        if (!this.props.isTeacherDataLoaded || this.props.refreshTeacherList) {
            this.props.getProductTeachers(this.props.selectedProduct.id);
        }

        if (!this.props.isClassroomDataLoaded) {
            this.props.getProductClassrooms(this.props.selectedProduct.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isTeacherDataLoaded ||
            isListDifferent(nextProps.filteredTeachers, this.props.filteredTeachers, 'userProfileId')) {
            this.rows = createTeacherRows(nextProps.filteredTeachers);
            this.setState({ rows: this.rows });
        }

        if (nextProps.refreshTeacherList && nextProps.refreshTeacherList !== this.props.refreshTeacherList) {
            this.props.getProductTeachers(this.props.selectedProduct.id);
        }

        this.setState({ dataFilterOption: this.props.dataFilterOption });
        if (nextProps.deleteSuccess !== this.props.deleteSuccess && nextProps.deleteSuccess) {
            const { notDeletedTeachers } = nextProps;
            this.setState({ showModal: false });

            const teacherDeleted = notDeletedTeachers.filter(teacher => !teacher.hasError);

            if (teacherDeleted.length === notDeletedTeachers.length) {
                this.props.showToast(this.props.intl.formatMessage(messages.deleteTeacherSuccessMessage, { count: notDeletedTeachers.length }), 'success');
            } else {
                this.props.showToast(this.props.intl.formatMessage(messages.deleteTeacherWarningMessage, { count: teacherDeleted.length || '0' }), 'warning');
            }
        }
    }

    filterClassrooms = (classrooms) => {
        const classes = classrooms.map(item => ({
            key: item.name,
            value: item.name,
            classroomId: item.classroomId
        }));
        return classes;
    }

    handleOnPrintSignInCard() {
        const teacherProfileIds = [];
        teacherProfileIds.push(this.props.lastAddedTeacherUserProfileId);
        this.props.printTeacherSignInCard(this.props.selectedProduct.id,
            { teacherUserProfileIds: teacherProfileIds, SignInCardPageSizeType: 'QR_3X3' });
    }

    handleOnPrintMultipleSignInCard() {
        this.props.printTeacherSignInCard(
            this.props.selectedProduct.id,
            { teacherUserProfileIds: this.props.selectedTeachers, SignInCardPageSizeType: 'QR_3X3' });
    }

    handleGridSort(sortColumn) {
        this.props.sortTeacherList(sortColumn);
    }

    handleOnDownloadTeacherRoll = () => {
        this.props.downloadTeacherRoll(this.props.filteredTeachers, false);
    }

    handleOnQuickUpload = () => {
        this.context.router.history.push('quickUpload');
    }

    handleOnAddTeacher = () => {
        this.props.openAddTeacherModal();
    }

    reloadTeacherList = () => {
        const refreshTeacherList = (this.props.lastAddedTeacherUserProfileId > 0);
        if (refreshTeacherList) {
            this.props.getProductTeachers(this.props.selectedProduct.id);
        }
    }

    handleOnCloseAddTeacherModal = () => {
        this.setState({ canSubmit: false });
        this.props.closeAddTeacherModal();
        this.reloadTeacherList();
    }

    handleOnCloseAddTeacherValidationModal = () => {
        this.setState({ canSubmit: true });
        this.props.closeAddTeacherValidationModal();
    }

    handleFilterOnClear = () => {
        this.props.clearFilterValue();
    }

    handleFilterOnChange = (collectionName, key) => {
        this.props.changeFilterValue(collectionName, key);
    }

    handleOnSearch = (searchTerm) => {
        this.props.updateSearchTerm(searchTerm);
    }

    handleRowSelect = (rows) => {
        this.props.retrieveSelectedTeachers(rows);
    }

    handleOnAddTeacherSubmit = () => {
        const { selectedProduct } = this.props;
        const teacher = clone(this.props.teacher);
        teacher.classroomId = parseInt(teacher.classroomId, 10);
        teacher.productId = selectedProduct.id;
        delete teacher.classrooms;
        this.setState({ canSubmit: false });
        this.props.addTeacher(teacher);
    }

    handleOnTeacherUnassign= () => {
        this.setState({ showModal: true });
        this.props.openUnAssignTeachersModal();
    }

    handleOnUnassignConfirm = () => {
        this.props.unassignTeachers(this.props.selectedTeachers, this.props.selectedProduct.id);
    }

    handleOnCloseModal = () => {
        this.setState({ showModal: false });
        this.props.resetUserClassroomRelation();
    }

    handleOnAddAnotherTeacher = () => {
        this.props.addAnotherTeacherModal();
    }

    teachersOperationSuccessConfirmation =() => {
        this.handleOnCloseModal();
        this.props.closeTeachersOperationConfirmationModal();
    }

    handleOnTeacherEdit = (userProfileId) => {
        this.context.router.history.push(`/edit-teacher/${userProfileId}`);
    }

    handleOnAssignClass = (id) => {
        const assignType = 'classToTeacher';
        this.context.router.history.push(`/assign-user/${id}/${assignType}`);
    }

    handleOnTeacherDeleteOpenModal = () => {
        const { teachers } = this.props;

        let hasClassroomsAssigned = false;
        let hasProductsAssigned = false;

        teachers.find((teacher) => {
            if (this.props.selectedTeachers.indexOf(teacher.userProfileId) !== -1 && teacher.assignedClassrooms.length > 0) {
                hasClassroomsAssigned = true;
            }

            if (teacher.accessibleProducts && teacher.accessibleProducts.length > 0) {
                hasProductsAssigned = true;
            }

            if (hasClassroomsAssigned && hasProductsAssigned) {
                return true;
            }

            return false;
        });

        if (hasClassroomsAssigned) {
            this.props.showToast(this.props.intl.formatMessage(messages.errorOnDeletingAssignedTeachers), 'error');
        } else if (hasProductsAssigned) {
            this.setState({ showModal: true });
            this.props.openDeleteTeacherModal();
        } else {
            this.handleOnDeleteTeacher();
        }
    }

    handleOnDeleteTeacher = () => {
        this.props.deleteTeacherRequest(this.props.selectedTeachers);
    }

    handleOnTeacherBulkPasswordChange = () => {
        this.setState({ showModal: true, bulkPasswordValue: '' });
        this.props.openBulkPasswordChangeTeachersModal();
    }

    handleOnTeacherBulkPasswordChangeNewValue = (event) => {
        this.setState({
            bulkPasswordValue: event.target.value.trim()
        });
    }

    handleOnBulkPasswordChangeConfirm = () => {
        this.props.bulkPasswordChangeTeachersRequest(this.props.selectedTeachers, this.state.bulkPasswordValue);
    }

    handleOnSendEmailVerification = () => {
        this.props.sendVerificationEmailRequest(this.props.selectedTeachers);
    };

    handleOnCloseEmailVerificationModal = () => {
        this.props.closeVerificationModal();
    };

    render() {
        const rowGetter = rowNumber => this.state.rows[rowNumber];
        return (
            <TeacherRoll
                addTeacherValidationMessage={this.props.addTeacherValidationMessage}
                bulkPasswordValue={this.state.bulkPasswordValue}
                classrooms={this.props.classrooms}
                closeAddTeacherValidationModal={this.handleOnCloseAddTeacherValidationModal}
                dataFilterOptions={this.state.dataFilterOption}
                deletingTeacher={this.props.deletingTeacher}
                emailVerificationError={this.props.emailVerificationError}
                filteredTeachersCount={this.props.filteredTeachers.length}
                filterOnChange={this.handleFilterOnChange}
                filterOnClear={this.handleFilterOnClear}
                gridRowGetter={rowGetter}
                handleOnAddTeacherSubmit={this.handleOnAddTeacherSubmit}
                handleOnAssignClass={this.handleOnAssignClass}
                handleOnBulkPasswordChangeConfirm={this.handleOnBulkPasswordChangeConfirm}
                handleOnChangeBulkPasswordSetValue={this.handleOnTeacherBulkPasswordChangeNewValue}
                handleOnCloseEmailVerificationModal={this.handleOnCloseEmailVerificationModal}
                handleOnCloseModal={this.handleOnCloseModal}
                handleOnDeleteTeacher={this.handleOnDeleteTeacher}
                handleOnPrintMultipleSignInCard={this.handleOnPrintMultipleSignInCard}
                handleOnPrintSignInCard={this.handleOnPrintSignInCard}
                handleOnTeacherBulkPasswordChange={this.handleOnTeacherBulkPasswordChange}
                handleOnTeacherDeleteOpenModal={this.handleOnTeacherDeleteOpenModal}
                handleOnTeacherEdit={this.handleOnTeacherEdit}
                handleOnTeacherUnassign={this.handleOnTeacherUnassign}
                handleOnUnassignConfirm={this.handleOnUnassignConfirm}
                isEmailVerificationModalOpen={this.props.isEmailVerificationModalOpen}
                isLoading={this.props.disableConfirmationButtons}
                isSaveInProgress={this.props.isSaveInProgress}
                isSignInCardDownloaded={this.props.isSignInCardDownloaded}
                isTeacherDataLoaded={this.props.isTeacherDataLoaded}
                isTeacherRollDownloaded={this.props.isTeacherRollDownloaded}
                isUserOperationModalOpen={this.props.isUserOperationModalOpen}
                onAddAnotherTeacher={this.handleOnAddAnotherTeacher}
                onAddTeacher={this.handleOnAddTeacher}
                onAddTeacherCloseModal={this.handleOnCloseAddTeacherModal}
                onDownloadTeacherRoll={this.handleOnDownloadTeacherRoll}
                onGridSort={this.handleGridSort}
                onQuickUpload={this.handleOnQuickUpload}
                onRowSelect={this.handleRowSelect}
                onSearch={this.handleOnSearch}
                operationType={this.props.operationType}
                selectedProduct={this.props.selectedProduct}
                selectedTeachers={this.props.selectedTeachers}
                sendingEmailsResult={this.props.sendingEmailsResult}
                showAddTeacherConfirmationModal={this.props.showAddTeacherConfirmationModal}
                showAddTeachersModal={this.props.showModal}
                showAddTeacherValidationModal={this.props.showAddTeacherValidationModal}
                showModal={this.state.showModal}
                teacher={this.props.teacher}
                teachers={this.state.rows}
                teachersCount={this.props.teachers.length}
                teachersOperationSuccessConfirmation={this.teachersOperationSuccessConfirmation}
                teacherTitles={this.props.teacherTitles}
            />
        );
    }
}

function mapStateToProps(state = {}) {
    return {
        ...state,
        classrooms: state.classRoll.classrooms,
        selectedProduct: state.product,
        teachers: state.teacherRoll.teachers,
        teacherTitles: state.teacherRoll.teacherTitles,
        filteredTeachers: state.teacherRoll.filteredTeachers,
        selectedTeachers: state.teacherRoll.selectedTeachers,
        isTeacherDataLoaded: state.teacherRoll.isTeacherDataLoaded,
        isClassroomDataLoaded: state.classRoll.isClassroomDataLoaded,
        isEmailVerificationModalOpen: state.teacherRoll.isEmailVerificationModalOpen,
        sendingEmailsResult: state.teacherRoll.sendingEmailsResult,
        emailVerificationError: state.teacherRoll.emailVerificationError,
        isYearGroupDataLoaded: state.teacherRoll.isYearGroupDataLoaded,
        isTeacherRollDownloaded: state.teacherRoll.isTeacherRollDownloaded,
        dataFilterOption: state.teacherRoll.dataFilterOption,
        showModal: state.teacherRoll.showModal,
        teacher: state.teacherRoll.teacherModel,
        isSaveInProgress: state.teacherRoll.isSaveInProgress,
        showAddTeacherValidationModal: state.teacherRoll.showAddTeacherValidationModal,
        addTeacherValidationMessage: state.teacherRoll.addTeacherValidationMessage,
        isSignInCardDownloaded: state.teacherRoll.isSignInCardDownloaded,
        showAddTeacherConfirmationModal: state.teacherRoll.showAddTeacherConfirmationModal,
        lastAddedTeacherUserProfileId: state.teacherRoll.lastAddedTeacherUserProfileId,
        isUserOperationModalOpen: state.teacherRoll.isUserOperationModalOpen,
        refreshTeacherList: state.teacherRoll.refreshTeacherList,
        disableConfirmationButtons: state.teacherRoll.disableConfirmationButtons,
        operationType: state.teacherRoll.operationType,
        deletingTeacher: state.teacherRoll.deletingTeacher,
        deleteSuccess: state.teacherRoll.deleteSuccess,
        notDeletedTeachers: state.teacherRoll.notDeletedTeachers
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getProductTeachers,
        getProductClassrooms,
        downloadTeacherRoll,
        clearFilterValue,
        changeFilterValue,
        updateSearchTerm,
        sortTeacherList,
        retrieveSelectedTeachers,
        openAddTeacherModal,
        closeAddTeacherModal,
        addTeacher,
        closeAddTeacherValidationModal,
        printTeacherSignInCard,
        unassignTeachers,
        addAnotherTeacherModal,
        openUnAssignTeachersModal,
        closeTeachersOperationConfirmationModal,
        openDeleteTeacherModal,
        deleteTeacherRequest,
        sendVerificationEmailRequest,
        closeVerificationModal,
        openBulkPasswordChangeTeachersModal,
        bulkPasswordChangeTeachersRequest,
        showToast,
        resetUserClassroomRelation
    }, dispatch);
}
const intlContainer = injectIntl(TeacherRollContainer);
export default connect(mapStateToProps, mapDispatchToProps)(intlContainer);



// WEBPACK FOOTER //
// ./app/containers/teacher-roll/index.js